<template>
  <div id="app">
    <div @click="hideTooltips($event)">
      <home-view
        v-if="view == 'home'"
        v-on:changeview="changeView($event)"
        :minHeight="getMinHeight()"
      ></home-view>

      <compagny-view
        v-if="view == 'compagny'"
        v-on:changeview="changeView($event)"
        :minHeight="getMinHeight()"
      ></compagny-view>

      <themes-list-view
        v-if="view == 'themesList'"
        v-on:changeview="changeView($event)"
        :minHeight="getMinHeight()"
      ></themes-list-view>

      <theme-view
        v-if="view == 'theme'"
        :theme="theme"
        v-on:changeview="changeView($event)"
        v-on:themeDeleted="changeView({view:'themesList'})"
        :minHeight="getMinHeight()"
      ></theme-view>

      <synthesis-view
        v-if="view == 'synthesis'"
        v-on:changeview="changeView($event)"
        :minHeight="getMinHeight()"
      ></synthesis-view>

      <page-footer
        ref="pageFooter"
        v-if="view != 'home'"
        :view="view"
        :activeTheme="theme"
        v-on:changeview="changeView($event)"
      ></page-footer>

      <page-footer-inrs ref="pageFooterInrs"></page-footer-inrs>

      <!-- TODO n'instancier les popins que lors de leur utilisation -->
      <popin-delete-element
        v-on:themeDeleted="view = 'themesList'"
      ></popin-delete-element>

      <popin-add-theme-element></popin-add-theme-element>

      <popin-print
        :currentView="view"
        :currentTheme="theme"
      ></popin-print>

      <popin-how-to-use></popin-how-to-use>

      <popin-open-save v-on:newContextLoaded="rerender()"></popin-open-save>

      <popin-error></popin-error>

      <popin-editorial-content :content="popinEditorialCt"></popin-editorial-content>
    </div>
  </div>
</template>

<script>
import HomeView from "./views/HomeView";
import CompagnyView from "./views/CompagnyView";
import ThemesListView from "./views/ThemesListView";
import ThemeView from "./views/ThemeView";
import SynthesisView from "./views/SynthesisView";
import PageFooter from "./components/PageFooter";
import PageFooterInrs from "./components/PageFooterInrs";
import PopinDeleteElement from "./components/popins/PopinDeleteElement";
import PopinAddThemeElement from "./components/popins/PopinAddThemeElement";
import PopinPrint from "./components/popins/PopinPrint";
import PopinHowToUse from "./components/popins/PopinHowToUse";
import PopinOpenSave from "./components/popins/PopinOpenSave";
import PopinError from "./components/popins/PopinError";
import PopinEditorialContent from "./components/popins/PopinEditorialContent";

import axios from "axios";

export default {
  name: "app",
  components: {
    HomeView,
    CompagnyView,
    ThemesListView,
    ThemeView,
    SynthesisView,
    PageFooter,
    PageFooterInrs,
    PopinDeleteElement,
    PopinAddThemeElement,
    PopinPrint,
    PopinHowToUse,
    PopinOpenSave,
    PopinError,
    PopinEditorialContent
  },
  computed: {
    gpsst: function() {
      return this.$store.state.gpsstModule.gpsst;
    }
  },
  watch: {
    view: function() {
      this.$nextTick(this.loadMinHeight);
    }
  },
  mounted: function() {
    window.vueApp = this;

    // affiche la popin d'explications selon la vue et selon si l'utilisateur a cliqué sur "J'ai compris"
    if (sessionStorage.getItem("howTo") === null && this.view == "home") {
      this.$bvModal.show("howTo");
    }

    this.loadMinHeight();
    window.addEventListener("resize", this.loadMinHeight);
  },
  data: function() {
    return {
      openTooltips: [],
      serverData: { data: null, urls: null },
      theme: {},
      view: "home", // view = home | synthesis | themesList | compagny | theme
      popinEditorialCt: "",
      minHeight: ""
    };
  },
  created: function() {
    var localData = sessionStorage.getItem("gpsst");

    // On stocke les URLs du fichier config.json dans le store afin de pouvoir les utiliser par la suite
    this.$store.commit("SET_CONFIG", window.gpsstConfig); 

    // Si des données sont disponibles dans le session storage et que c'est un JSON valide, on les utilise pour initialiser le store
    if (localData && this.IsValidJSONString(localData)) {
      this.$store.dispatch("overwriteGpsst", JSON.parse(localData));
      this.initializeAppState(JSON.parse(localData).compagnyContext);
    } else {
      var jsonUrl = this.$store.state.appState.urls.URL_JSONdata;
      
      // En DEV seulement: si une URL de fichier de config JSON est fourni en paramètre d'URL, on l'utilise
      if (this.$store.state.appState.env === "DEV") {
        var v = this.getQueryParameter("URL_JSONdata");
        if (v) {
          jsonUrl = v;
        }
      }

      // Sinon, si aucune donnée valide n'est disponible dans le session storage, on récupère le fichier de configuration métier disponible sur le backend
      axios
        .get(jsonUrl) // on utilise l'URL stockée dans le store
        .then(response => {
          this.serverData = response.data;
          this.$store.dispatch("initializeState", this.serverData); // si le backend renvoie les données on les utilise pour initialiser le state gpsstModule du store
          this.initializeAppState(this.serverData.compagnyContext); // on initialise ensuite le module appState du store, ce qui consiste uniquement à initialiser la variable "compagnyCompleted"
        })
        .catch(e => {
          // dans le cas où le backend ne renvoie pas les données
          this.$store.commit("SET_ERROR", {
            title: this.$i18n.t("global.error.title"),
            text: this.$i18n.t("global.error.jsonDataUnavailable")
          }); // on récupères les textes liés à cette erreur

          this.$bvModal.show("error"); // on affiche la popin qui permet alors d'indiquer l'erreur à l'utilisateur
          //TODO bloquer l'utilisation de l'application 

          if (this.$store.state.appState.env === "DEV") {
            // dans le cas où on est en dev, on affiche l'erreur dans la console.
            console.error("Impossible de charger les données métier GPSST", e);
          }
        });
    }
  },
  methods: {
    // test si la variable passée en paramètre est un JSON valide
    IsValidJSONString: function(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    loadMinHeight: function() {
      const appTop = this.$el.getBoundingClientRect().top + window.pageYOffset;
      const stepBar = this.$refs.pageFooter ? this.$refs.pageFooter.$el.offsetHeight : 0;
      this.minHeight = "min-height:" + (window.innerHeight - appTop - stepBar - document.getElementById("navbarinrs").clientHeight) + "px";
    },
    getMinHeight: function() {
      return this.minHeight;
    },
    // ferme les tooltips ouverts uniquement - comportement pour tablette
    hideTooltips: function(event) {
      if (
        typeof event.srcElement.className !== "string" ||
        !event.srcElement.className.includes("icon-tooltip")
      ) {
        for (let i = this.openTooltips.length; i >= 0; i--) {
          // pas besoin du tableau si on decide de toujours tout hide avant d'ouvrir un tooltip
          this.$root.$emit("bv::hide::tooltip", this.openTooltips[i]);
          this.openTooltips.splice(i, 1);
        }
      } else if (
        typeof event.srcElement.className === "string" &&
        event.srcElement.className.includes("icon-tooltip")
      ) {
        this.openTooltips.push(event.srcElement.id);
      }
    },
    // fonction utilisée lors du chargement d'un nouveau context afin de mettre à jour l'app
    rerender: function() {
      this.reRenderKey += 1;
      //if (this.view === "theme" || this.view === "synthesis") {
      this.view = "home";
      //}
    },
    initializeAppState: function(compagnyContext) {
      // si les champs obligatoires du contexte de l'entreprise sont déjà remplis, l'accès aux thèmes est autorisé
      if (compagnyContext) {
        if (
          compagnyContext.name != "" &&
          compagnyContext.unitName != "" &&
          compagnyContext.completionPeriods.currentDate != ""
        ) {
          this.$store.commit("VALIDATE_COMPAGNY_COMPLETED");
        }
      }

      // pour chaque theme, renseigner l'état actuel de la saisie
    },
    changeView: function(params) {
      window.scrollTo(0, 0);

      this.view = params.view;
      if (params.view == "theme") {
        this.theme = params.theme;
      }
    },
    showEditorialContentInPopin : function(content) {
      this.popinEditorialCt = content;
      this.$bvModal.show("editorialContent");
    },
    parseQueryString: function(query) {
      var vars = query.split("&");
      var query_string = {};
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
          query_string[key] = decodeURIComponent(value);
          // If second entry with this name
        } else if (typeof query_string[key] === "string") {
          var arr = [query_string[key], decodeURIComponent(value)];
          query_string[key] = arr;
          // If third or later entry with this name
        } else {
          query_string[key].push(decodeURIComponent(value));
        }
      }
      return query_string;
    },
    getQueryParameter : function(name) {
      var pqs = this.parseQueryString(window.location.search.substring(1));
      return Object.prototype.hasOwnProperty.call(pqs, name) ? pqs[name] : null;
    }
  }
};
</script>

<style lang="sass">
@import "./sass/_variables.sass"
@import "./sass/_media.sass"

.bandeauMilieu
  box-sizing: content-box !important

.view 
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif
  @media screen and (max-width: 768px)
    margin: 0 30px
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  //-webkit-print-color-adjust: exact  
  margin: 0 auto
  max-width: 920px
  word-break: break-word
  padding: 0 10px 3em 10px

html, body
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif
  font-size: 13px
  line-height: 1.3

  @media print
    font-family: sans_serif_webfont, Arial, "Helvetica Neue", Helvetica, sans-serif
    font-size: 9pt

/* Bouton par défaut */
.defaultButton
  box-shadow: -1px 2px 5px 0 rgba(0,0,0,0.2) !important
  color: white
  background: linear-gradient(to bottom,  $darkgray-2 0%, $darkgray-1 100%)
  border: none 
  border-radius: 0
  font-size: 1em
  font-weight: bold
  padding: 0.4em 0.8em  
  text-align: left
  //display: flex
  
  @include ieOnly
    display: inline-block


  // Au survol ou focus
  &:hover, &:focus
    border: none
    text-decoration: underline
    background: linear-gradient(to bottom,  $darkgray-1 0%, $darkgray-2 100%)

  // Bouton sélectionné (effet enfoncé)
  &.selected
    cursor: default
    //border: 1px inset $lightgray-1 !important
    box-shadow: inset -1px 2px 5px 0 rgba(0,0,0,0.2) !important
    opacity: 1 !important
    box-shadow: none
    background: linear-gradient(to bottom,  $darkgray-1 0%, $darkgray-2 100%)

  // Bouton désactivé      
  &.disabled
    opacity: 0.5
    &:hover, &:focus 
      text-decoration: none !important
      background: linear-gradient(to bottom,  $darkgray-2 0%, $darkgray-1 100%)


  // Pictogramme fontawsome dans le bouton
  i
    margin: 0 0.5em 0 0
    .right
      margin: 0 0 0 0.5em
    .left
      margin: 0 0.5em 0 0

  // Pictogramme image dans le bouton
  img
    margin: 0 0.5em 0 0
    height: 1.3em
    width: auto
    vertical-align: middle
    position: relative
    top: -0.1em

  // Version flottante à droite du bouton
  &.floatRight
    float: right  

  // Version orange du bouton
  &.orange
    border : none
    background: linear-gradient(to bottom, $lightorange-color 0%, $orange-color 100%)
    &:hover, &:focus
      background: linear-gradient(to bottom, $orange-color 0%, $lightorange-color 100%)

// décalage du picto positionné à gauche d'un texte
.right
  margin-right: 0.5em
// décalage du picto positionné à droite d'un texte
.left
  margin-left: 0.5em !important

.mymodal
  .close-icon
    position: absolute
    right: 0.5em
    top: 0.5em
    cursor: pointer
    &:hover, &:focus
      color: $orange-color
  .modal-dialog
    @include xl
      margin-right: 3em
      margin-left: 3em
      max-width: none !important
  .mymodalContent
    border-radius: 0% !important  
    border: none !important
  .modal-div
    padding: 1em
    .buttons-div
      padding-top: 2em
  h2
    font-weight: 800 !important
    font-size: 2.615rem !important
    margin-bottom: 20px !important
    line-height: 1.1 !important
    color: var(--color-charcoal, #161616) !important
    font-family: inherit !important
    &:first-of-type
      margin-top: 0
  button
    font-weight: bold

  .popin-actions
    display: flex
    justify-content: space-between
    align-items: center
    gap: 10px
    margin-top: 1.5em

    @media (max-width: 576px)
      flex-direction: column

      .popin-btn-cancel,
      .popin-btn-confirm
        width: 100%
        justify-content: center

  .popin-btn-cancel
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 8px
    font-family: 'brother-1816', pt_sans, Arial, "Helvetica Neue", Helvetica, sans-serif
    font-weight: 700
    font-size: 1.38rem
    line-height: 1.2
    text-align: center
    color: #161616 !important
    min-height: 48px
    height: auto
    border: 1px solid #161616 !important
    border-radius: 52px
    background: transparent !important
    padding: 0.5rem 1.5rem
    box-shadow: none !important

    &:hover, &:focus, &:active
      background: transparent !important
      color: #161616 !important
      border-color: #161616 !important
      box-shadow: none !important
      text-decoration: none !important
      opacity: 1 !important

  .popin-btn-confirm
    justify-content: center
    line-height: 1.2
    text-align: center
    min-height: 48px
    height: auto !important
    padding-top: 0.5rem
    padding-bottom: 0.5rem

/* code appliqué à IE uniquement */
::-ms-expand
  input.myinput
    line-height: 0.7

.form-group-label
  font-weight: bold
  margin-bottom: 0.25em
  padding-bottom: 0

.form-group-label.marginBefore
    padding-top:1em !important

.mx-datepicker
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif !important
  font-size: 1em !important

.mx-input-append
  padding: 2px 6px 4px 6px !important

.myinput, .mx-input
  font-size: 1.23rem !important
  border-radius: 0% !important
  height: auto
  padding:0.3em 0.5em

  &::placeholder
    color: $gray-4
    
  &:focus 
    border-color:#ccc !important
    outline: 0 !important
    box-shadow: none !important

  &:read-only
    background: transparent !important
    overflow: visible !important
    border: none !important
    height: auto !important
    padding: 0

.mx-input
  padding-right:2em 

.printedField
  &.textarea
    white-space: pre-wrap
    display: block

  &.bordered
    border: 1px solid $lightgray-1
    padding: 0.5em

.myradio
  color: $darkgray-1

.myOrangeTitle
  font-size: 1.38rem
  font-weight: 800
  margin-bottom: 1.53rem
  color: #161616
  margin: 1em 0 0.25em 0
  clear: both



.subtitle
  color: $darkgray-3
  font-weight: bold
  padding-bottom: 10px
  //width: 96%

.themeElementContainer
  background: $lightgray-3
  border: 1px solid white
  color: #000
  padding: 1em

  @media print
    background: transparent
    padding: 0

// le style doit être global car la classe est exécutée dans le v-html
.edit-icon
    margin-right: 5px
    margin-bottom: 2px

.form-control
  line-height: 1.3

.form-check-label
    user-select: none

.fit-icon-picture
  height: 1.3em
  width: auto
  vertical-align: middle
  //position: relative
  //top: -0.1em

.info-icon
  height: 10px
  width: 10px
  margin: 5px

.fit-medium-icon-picture 
  width: 14px
  height: 14px
  margin: 3px
  cursor: pointer

.slice-title
  color: white
  font-weight: bold
  font-size: 1.23rem
  margin: 2px
  padding: 2px 4px  

.asterisk
  color: $red-info
  
.warning-msg
  color: $red-info
  display: flex
  align-items: baseline
  margin: 1em 0
  font-weight: bold
  font-size: 1.23rem

  .material-design-icon
    margin-right: 0.5em
    font-size: 1.2em

.invalid-feedback
  font-size: 0.9em

.material-design-icon
  svg
    width: 1.4em
    height: 1.4em

  &.plus-icon
    svg
      font-size: 1.2em
      margin: -0.2em

  &.big
    font-size: 1.5em

button
    &.right
      margin-left: 0.4em
      margin-right: 0

.icon-tooltip
  color: $gray-4
  cursor: help
  margin:0 0.3em
  font-size: 1.23rem

.clickable
  cursor: pointer

select
  white-space: nowrap

.view .inrs-entete__sousTitle
  margin: 50px 0 20px
  font-weight: 800
  font-size: 2.615rem

p, label
  font-size: 1.23rem

.editorial
  p, p *, li, li *
    font-weight: 350
  strong, strong *
    font-weight: 700 !important

</style>
